import React, { Component } from 'react';
import GoogleCalendarAppointmentPicker from './GoogleCalendarAppointmentPicker';
import axios from 'axios';


class App extends Component
{
  constructor(props)
  {
    super(props);

    this.state = 
    {
      leadlazarus_api_data: props.leadlazarus_api_data
    };

    this.render_google_calendar_button = this.render_google_calendar_button.bind(this);
  }

  render_google_calendar_button()
  {
    const _this = this;
    return <GoogleCalendarAppointmentPicker leadlazarus_api_data={_this.state.leadlazarus_api_data}
                                            post_appointment_url="/api/lead_appointment"/>;
  }

  render()
  {
    const _this = this;

    return (
      <div className="App">
        {_this.render_google_calendar_button()}
      </div>
    );
  }
};

export default App;
